/**
 * Converts a value in degrees to radians
 * @param {number} value Value in degrees
 * @returns {number} Value in radians
 */
export function toRadians(value: number) {
  return value * Math.PI / 180;
}


/**
 * Converts a value in radians to degrees
 * @param {number} value Value in radians
 * @returns {number} Value in degrees
 */
export function toDegrees(value: number) {
  return value * 180 / Math.PI;
}


/**
 * Returns the cardinal direction ("N", "E", "S", "W") based on a bearing in degrees.
 * @param {number} bearing Bearing in degrees
 * @returns {string} Cardinal direction ("N", "E", "S", "W")
 */
export function getCardinalDirection(bearing: number): string {
  bearing = bearing % 360;  // Normalize bearing to range [0,360)
  const index = Math.round(bearing * 4 / 360) % 4;
  return ['N', 'E', 'S', 'W'][index];
}


/**
 * Returns the intercardinal direction ("N", "NE", "E", "SE", etc.) based on a bearing in degrees.
 * @param {number} bearing Bearing in degrees
 * @returns {string} Intercardinal direction ("N", "NE", "E", "SE", etc.)
 */
export function getIntercardinalDirection(bearing: number): string {
  bearing = bearing % 360;  // Normalize bearing to range [0,360)
  const index = Math.round(bearing * 8 / 360) % 8;
  return ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'][index];
}

/**
 * Returns the 16 intercardinal directions ("N", "NNE", "NE", "ENE", "E", etc.) based on a bearing in degrees.
 * @param {number} bearing Bearing in degrees
 * @returns {string} Expanded Intercardinal direction ("N", "NNE", "NE", "ENE", "E", etc.)
 */
export function getEveryIntercardinalDirection(bearing: number): string {
  bearing = bearing % 360;  // Normalize bearing to range [0,360)
  const index = Math.round(bearing * 16 / 360) % 16;
  return ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'][index];
}
